export const HELP_LINKS = {
  otpOffersMigration:
    'https://help.playbookapp.io/en/articles/15924965-otp-programs-otp-offers-what-s-changing-and-what-s-not',
  promotionsSetup:
    'https://help.playbookapp.io/en/articles/9554257-how-to-set-up-promotions-for-your-products-and-subscriptions',
} as const;
